import React, { useMemo } from 'react';
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    CustomInput,
    FormGroup,
    Input,
    Label,
    Row,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';

export default function FormSociedad({
    denominacion,
    capFijo,
    capVariable,
    totalAcciones,
    onDenominacionChange,
    onCapFijoChange,
    onCapVariableChange,
    onTotalAccionesChange,
    mostrarAcciones,
    esConstitutiva,
    tipoRepresentacion = 'acciones',
    onTipoRepresentacionChange,
}) {
    const valorAccion = useMemo(() => {
        const totalNum = parseFloat(totalAcciones || '0');
        if (!totalNum || totalNum <= 0) return '0.00';
        const suma =
            parseFloat(capFijo || '0') + parseFloat(capVariable || '0');
        return (suma / totalNum).toFixed(2);
    }, [capFijo, capVariable, totalAcciones]);

    const esAcciones = tipoRepresentacion === 'acciones';
    const esParticipaciones = tipoRepresentacion === 'participaciones';

    return (
        <Card className="mb-4 shadow-sm">
            <CardHeader className="border-bottom border-danger">
                <h5 className="mb-0 d-flex align-items-center">
                    <FontAwesomeIcon icon={faBuilding} className="text-danger mr-2" />
                    Identificación del Asunto Principal
                </h5>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            {
                                esConstitutiva ? (
                                    <Label for="pldDenominacion">
                                        Denominación de la sociedad a constituir *
                                    </Label>
                                ) : (
                                    <Label for="pldDenominacion">
                                        Denominación de la sociedad o persona *
                                    </Label>
                                )
                            }

                            <Input
                                id="pldDenominacion"
                                type="text"
                                value={denominacion}
                                onChange={onDenominacionChange}
                                placeholder="Ej. Empresa Patito S.A."
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label className="mb-2">Representación del capital:</Label>
                            <div className="d-flex align-items-center flex-wrap">
                                <CustomInput
                                    type="checkbox"
                                    id="repAcciones"
                                    label="Acciones"
                                    checked={esAcciones}
                                    onChange={() => onTipoRepresentacionChange('acciones')}
                                    className="mr-2 mb-2"
                                />
                                <CustomInput
                                    type="checkbox"
                                    id="repParticipaciones"
                                    label="Partes Sociales"
                                    checked={esParticipaciones}
                                    onChange={() => onTipoRepresentacionChange('participaciones')}
                                    className="mb-2"
                                />
                            </div>
                        </FormGroup>
                    </Col>
                    <Col md="6" hidden={!mostrarAcciones}>
                        <div className="bg-light p-3 rounded border">
                            <h6 className="text-muted mb-3">
                                Cantidades (opcional según acto)
                            </h6>
                            <Row>
                                <Col xs="6">
                                    <FormGroup>
                                        <Label className="small text-uppercase text-muted mb-1">
                                            Cap. fijo ($)
                                        </Label>
                                        <Input
                                            type="number"
                                            value={capFijo}
                                            onChange={onCapFijoChange}
                                            min="0"
                                            step="any"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col xs="6">
                                    <FormGroup>
                                        <Label className="small text-uppercase text-muted mb-1">
                                            Cap. variable ($)
                                        </Label>
                                        <Input
                                            type="number"
                                            value={capVariable}
                                            onChange={onCapVariableChange}
                                            min="0"
                                            step="any"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            {esAcciones ? (
                                <Row className="pt-2 border-top">
                                    <Col xs="6">
                                        <FormGroup className="mb-0">
                                            <Label className="small text-uppercase text-danger mb-1">
                                                Total acciones
                                            </Label>
                                            <Input
                                                type="number"
                                                value={totalAcciones}
                                                onChange={onTotalAccionesChange}
                                                min="0"
                                                step="1"
                                                placeholder="Ej. 100"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col xs="6">
                                        <FormGroup className="mb-0">
                                            <Label className="small text-uppercase text-muted mb-1">
                                                Valor × acción
                                            </Label>
                                            <Input
                                                type="text"
                                                value={`$ ${valorAccion}`}
                                                disabled
                                                className="bg-light font-weight-bold text-muted"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            ) : null}
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
}
